import React from 'react';
import { benefits } from '../data/mock';
import { Shield, BadgeEuro, MapPin, Award } from 'lucide-react';
import abstractImage from '../assets/meistergruen-abstrakt.jpg';

const iconMap = {
  Shield,
  BadgeEuro,
  MapPin,
  Award,
};

const About = () => {
  return (
    <section id="ueber-uns" className="py-12 md:py-16 lg:py-24 bg-[#F5F7F2]">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-[32px] overflow-hidden shadow-2xl">
              <img
                src={abstractImage}
                alt="Abstrakte Illustration im MeisterGrün Stil"
                className="w-full h-[300px] md:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1E4D2B]/40 to-transparent" />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-white rounded-2xl p-4 sm:p-6 shadow-xl max-w-[150px] sm:max-w-[200px]">
              <div className="text-3xl sm:text-4xl font-bold text-[#1E4D2B] mb-0.5 sm:mb-1">10+</div>
              <div className="text-[#2D5F3A] text-xs sm:text-sm">Jahre Erfahrung in der Region</div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <span className="inline-block text-[#FFD700] font-semibold text-xs sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">
              Über uns
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#1E4D2B] mb-4 sm:mb-6 leading-tight">
              Warum MeisterGrün?<br className="hidden sm:block" />
              <span className="text-[#2D5F3A]"> Ihr Vorteil.</span>
            </h2>
            <p className="text-[#2D5F3A] text-base sm:text-lg mb-8 sm:mb-10 leading-relaxed">
              Als lokaler Hausmeisterservice in Frankfurt und Kahl am Main sind wir Ihr verlässlicher
              Partner für alle Arbeiten rund um Haus und Garten. Mit Leidenschaft und
              Sorgfalt kümmern wir uns um Ihre Immobilie.
            </p>

            {/* Benefits Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {benefits.map((benefit) => {
                const IconComponent = iconMap[benefit.icon];
                return (
                  <div
                    key={benefit.id}
                    className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 rounded-2xl hover:bg-white transition-colors duration-300"
                  >
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#FFD700] rounded-xl flex items-center justify-center flex-shrink-0">
                      {IconComponent && (
                        <IconComponent className="w-5 h-5 sm:w-6 sm:h-6 text-[#1E4D2B]" />
                      )}
                    </div>
                    <div>
                      <h3 className="font-semibold text-base sm:text-lg text-[#1E4D2B] mb-0.5 sm:mb-1">
                        {benefit.title}
                      </h3>
                      <p className="text-[#2D5F3A] text-xs sm:text-sm leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
